import ReqClient from './request.class'

// 获取开发者配置
export async function getDeveloperConfig(params) {
  const Req = new ReqClient({
    url: '/api/ptom/developerConfig/queryDeveloperConfig',
    method: 'POST',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取所有开发者配置
export async function queryAllDeveloperConfig() {
  const Req = new ReqClient({
    url: '/api/ptom/developerConfig/queryAllDeveloperConfig',
    method: 'POST'
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 编辑开发者配置
export async function updateDeveloperConfig(params) {
  const Req = new ReqClient({
    url: '/api/ptom/developerConfig/updateDeveloperConfig',
    method: 'POST',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 查询头条、腾讯广告、快手、百度的回调地址
export async function queryMediaCallbackAddr() {
  const Req = new ReqClient({
    url: '/api/ptom/developerConfig/queryMediaCallbackAddr',
    method: 'POST'
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 根据媒体查询改媒体下的所有账号
export async function queryAdAccountByMediaId(params) {
  const Req = new ReqClient({
    url: '/api/ptom/adAccount/queryAdAccountByMediaId',
    method: 'POST',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
